import { Fragment, createElement, useEffect, useState } from "react";

import React from "react";
import rehypeParse from "rehype-parse";
import rehypeReact from "rehype-react";
import { unified } from "unified";

//This is a custom hook that uses the unified library to parse and process the html content
function useProcessor(text) {
  const [Content, setContent] = useState(null);

  useEffect(() => {
    unified()
      .use(rehypeParse, { fragment: true })
      .use(rehypeReact, {
        createElement,
        Fragment,
        components: {
          a: (props) => {
            return (
              <a
                {...props}
                target="_blank"
                rel="noopener noreferrer"
                href={props.href}
                style={{
                  color: "#FFF",
                }}
              >
                {props.children}
              </a>
            );
          },
        },
      })
      .process(text)
      .then((file) => {
        setContent(file.result);
      });
  }, [text]);

  return Content;
}

export default function HtmlRenderer(props: { html: string }) {
  return useProcessor(props.html);
}
